$(document).ready(function() {
	if(!document.querySelector('.support-help-library')) return false;

	var supportHelpLibrary = function() {
		var cont = $('.support-help-library'),
			isSolution = false,
			productId,
			helpLibraryData,
			seeMoreBtn = cont.find('.btn-see-more a');	// 20200406 김우람 || SEE MORE param 추가

		// no-data content hidden
		// cont.find('.no-content').hide();
		// cont.find('.error-common').hide();

		// if Solution page
		if ( !!cont.find('.tabs-type-liner').length && !!cont.find('.tabs-menu-wrapper').length) isSolution = true;
		
		var tabs,
			url,
			max,
			product,
			sort,
			topic;

		var callHelpLibrary = function() {
			var dataTemp;
			if(isSolution) {
				// solution
				tabs = cont.find('.tabs-type-liner');
				url = tabs.data('url');
				max = tabs.data('max');
				sort = tabs.find('.btn-tab.active').data('sort');
				//topic = tabs.data('topic');

				if(!topic) topic="";

				var cate = tabs.data('category'),
					supercate = tabs.data('supercategory');
				// 20200416 START 김우람 || param topic -> symptom 변경
				if(url.indexOf('?') != -1) {
					url = url+'&sort='+sort+'&categoryId='+cate+'&superCategoryId='+supercate+'&symptom='+topic+'&limit='+max;
				} else {
					url = url+'?sort='+sort+'&categoryId='+cate+'&superCategoryId='+supercate+'&symptom='+topic+'&limit='+max;
				}
				// 20200416 END 김우람 || param topic -> symptom 변경
			} else {
				// psp
				tabs = cont.find('.tabs-menu-wrapper');
				url = tabs.data('url');
				max = tabs.data('max');
				product = tabs.data('product');
				sort = tabs.data('sort');
				url = url+'?sort='+sort+'&topic='+topic+'&search='+product+'&limit='+max;
			}
			return url;
		};
		function replaceHTMLHelpLibrary(isSolution, helpLibraryData) {
			var num = 0,
				html = '';

			if(typeof helpLibraryData == 'object') {
				if(helpLibraryData.flag=="Y") {
					var len = helpLibraryData.list.length;
					if(len>0) {
						if(len>max) len=max;
						for(i=0;i<len;i++) {
							html = html + '<li class="unit">';
							if (helpLibraryData.list[i].isVideo) html = html + '<div class="icon-wrapper"><span class="icon"><img src="/lg5-common-gp/images/support/icons/shooting.svg" alt=""></span></div>';
							else html = html + '<div class="icon-wrapper"><span class="icon"><img src="/lg5-common-gp/images/support/icons/document.svg" alt=""></span></div>';
							var isPick = helpLibraryData.list[i].itemtopflag;
							var pickHTML = (isPick=="Y") ? '<span class="recommendation">'+helpLibraryData.list[i].flagtext+'</span>':'';
							html = html + '<dl><dt><div class="eyebrow">'+xssfilter(helpLibraryData.list[i].eyebrow)+'</div><a href="'+xssfilter(helpLibraryData.list[i].linkURL)+'" data-link-area="cs_help_library_list_view_detail" data-link-name="'+xssfilter(helpLibraryData.list[i].adobeTitle)+'">'+pickHTML+xssfilter(helpLibraryData.list[i].title)+'</a></dt><dd>'+xssfilter(helpLibraryData.list[i].desciption)+'</dd></dl>';
							html = html + '</li>';
							num ++;
						}
						if(num>0) {
							cont.find('.unit-list').html(html);
							cont.find('.have-result').show();
							cont.find('.no-content').hide();
						} else {
							cont.find('.have-result').hide();
							cont.find('.no-content').show();
						}
					} else {
						// not yet
						cont.find('.have-result').hide();
						cont.find('.no-content').show();
					}
				}else if(helpLibraryData.flag=="N" && helpLibraryData.error.type == "downtime") {
					var $errorWrapper = cont.find('.error-common');

					$errorWrapper.find('.start-time').text(helpLibraryData.error.startTime);
					$errorWrapper.find('.end-time').text(helpLibraryData.error.endTime);

					cont.find('.have-result').hide();
					cont.find('.no-content').hide();
					cont.find('.error-common').show();
				}
			}
		}
		// 20200406 김우람 || SEE MORE param 추가
		function setSeeMoreBtnUrl( helpLibraryData ){
			var seeMoreBtnUrlArray = seeMoreBtn.attr('href').split('?');
			var seeMoreBtnUrl = seeMoreBtnUrlArray[0] + '?' + helpLibraryData.split('?')[1];

			seeMoreBtn.attr('href', seeMoreBtnUrl);
		}

		// PSP page for desktop
		cont.find('.tabs-menu-wrapper ul.menu-list li.menu a').on('click', function(event) {
			// click topic for desktop
			event.preventDefault();

			// change menu active
			$(this).closest('ul.menu-list').find('.active').removeClass('active').attr('aria-selected', "false");
			$(this).parent().addClass('active').attr('aria-selected', "true");
			//$('#helpLibraryList').attr('aria-labelledby', $(this).attr('id'));

			topic = $(this).data('topic');
			helpLibraryData = callHelpLibrary();

			setSeeMoreBtnUrl( helpLibraryData );	// 20200406 김우람 || SEE MORE param 추가

			ajax.call(helpLibraryData, null, 'json', function(data){
				replaceHTMLHelpLibrary(isSolution, data);
			});
		});
		// PSP page for mobile
		cont.find('.tabs-menu-wrapper div.menu-list select').change(function(event) {
			// change topic for mobile
			event.preventDefault();

			topic = $(this).val();
			helpLibraryData = callHelpLibrary();

			setSeeMoreBtnUrl( helpLibraryData );	// 20200406 김우람 || SEE MORE param 추가

			ajax.call(helpLibraryData, null, 'json', function(data){
				replaceHTMLHelpLibrary(isSolution, data);
			});
		});
		// Solutions page
		cont.find('.tabs-type-liner button.btn-tab').on('click', function() {
			// click sort button
			event.preventDefault();

			// change memu active
			$(this).closest('.tabs-type-liner').find('button.btn-tab').removeClass('active').attr('aria-selected', "false");
			$(this).addClass('active').attr('aria-selected', "true");
			$('#helpLibraryList').attr('aria-labelledby', $(this).attr('id'));

			// data
			//topic = $(this).val();
			helpLibraryData = callHelpLibrary();

			setSeeMoreBtnUrl( helpLibraryData );	// 20200406 김우람 || SEE MORE param 추가

			ajax.call(helpLibraryData, null, 'json', function(data){
				replaceHTMLHelpLibrary(isSolution, data);
			});
		});
	};

	var supportMenuInit = function() {
		var $window = $(window),
			$menu = $('.support-wrap'),
			$menuBtn = $menu.find('.btn-support'),
			$menuList = $menu.find('.support-list'),
			flag = $window.width() <= 991 ? true : false;
			

		var resizeEventHandler = function() {
			var width = $window.width();

			if (width <= 991 && flag) {
				$menu.removeClass('active');
				$menuBtn.prop('disabled', false);
				$menuBtn.attr('aria-expanded', true);
				flag = false;
			} else if (width > 991 && !flag) {
				$menu.removeClass('active');
				$menuBtn.prop('disabled', true);	
				$menuBtn.attr('aria-expanded', false);
				$menuList.removeAttr('style');
				flag = true;
			}
		}

		var clickEventHandler = function() {
			if ($menu.hasClass('active')) {
				$menu.removeClass('active');
				$menuBtn.attr('aria-expanded', false);
				$menuList.stop().slideUp();
			} else {
				$menu.addClass('active');
				$menuBtn.attr('aria-expanded', true);
				$menuList.stop().slideDown();
			}
		}

		resizeEventHandler();
		$menuBtn.on('click', clickEventHandler);
		$window.on('resize', resizeEventHandler);
			
	}

	var recently = {
		el: $('.support-wrap'),
		id: null,
		init:function(){
			var _this = this;
			_this.id = _this.el.data('productId');

			if (!_this.id){
				return;
			}
			// 20200402 START 김우람 || 모델 중복 수정
			// 20200406 START 전호근 || 스크립트 에러 수정
			var mktRecentlyCookie = _this.cookie.get(_this.cookie.cookieName);
			var b2bRecentlyCookie = _this.cookie.get(_this.cookie.cookieNameB2B);
			// 20200406 END 전호근 || 스크립트 에러 수정
			if (!!mktRecentlyCookie == true && mktRecentlyCookie.indexOf(_this.id) == 0){
				return;
			}

			if (!!b2bRecentlyCookie == true && b2bRecentlyCookie.indexOf(_this.id) == 0){
				return;
			}
			// 20200402 END 김우람 || 모델 중복 수정

			_this.cookie.bake(_this.cookie.cookieNameCST);
		},
		cookie: {
			// 20200319 START 김우람 || b2b,mkt RecentlyView 쿠키 삭제 
			cookieName: 'LG5_RecentlyView',
			cookieNameCST: 'LG5_CST_RecentlyView',
			cookieNameB2B: 'LG5_B2B_RecentlyView',
			maximum: 12,
			dough: null,
			bake: function(name){
				var _this = recently,
					_cookie = this;
				_cookie.dough = _cookie.get(name);

				if(!_cookie.dough){
					_cookie.dough = [_this.id];
				}else {
					if(typeof _cookie.dough == 'string') _cookie.dough = [_cookie.dough];

					var index = _cookie.dough.indexOf(_this.id);
					if(index == 0) {
						return false;
					}else if(index > 0){
						_cookie.dough.splice(index, 1);
					}
					_cookie.dough.unshift(_this.id);

					if(_cookie.dough.length > _cookie.maximum) {
						var del = _cookie.dough.length - _cookie.maximum;
						_cookie.dough.splice(_cookie.maximum, del);
					}
				}
				if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
					setCookie(name, _cookie.dough.join('|'), true);
				}
			},
			get: function(name){
				var _this = recently,
					_cookie = this,
					c = getCookie(name);

				if(c && c != '') {
					c = c.indexOf('|') >= 0 ? c.split('|') : c;
					return c;
				}else {
					return false;
				}
			},
		}
	}

	// 200429 START 전호근 - JP 다운로드 팝업
	var download = {
		el: document.querySelectorAll('.support-downloads'),
		init: function() {
			download.$link = $(download.el).find('.list .name a.link-text:not(.link)');
			download.$modal = $(document.getElementById('modal_file_download'));
			download.activeEvent();
		},
		fileModalOpen: function(e) {
			e.preventDefault();
			var $target = $(e.target);
			var $btn = download.$modal.find('.btn-download');
			var fileUrl = $target.attr('href');
			var type = $target.closest('li').find('.type').text();
			var modelName = $('.support-product-area .text-block .model').text();
			var fileName = $target.text();
			var fileType = $target.closest('li').hasClass('manuals') ? 'manuals_documents' : 'software_drivers';

			$btn.attr('href', fileUrl);
			$btn.data({
				'modelName': modelName,
				'fileType': fileType,
				'fileName': fileName,
				'type': type
			});
			download.$modal.modal('show');
		},
		fileModalClose: function(e) {
			var $btn = download.$modal.find('.btn-download');
			// 200520 전호근 - download error 수정 
			// $btn.attr('href', '#');
			$btn.removeData(['fileType', 'modelName', 'fileName', 'type']);
		},
		fileDownload: function(e) {
			var $this = $(this);
			var fileName = changeTitleFormat($this.data('type')) + ':' + changeTitleFormat($this.data('modelName')) + ':' + changeTitleFormat($this.data('fileName'));
			// 200506 전호근 - JP 다운로드 팝업
			download.$modal.modal('hide');
			adobeTrackEvent('cs-psp-download', {download_file_type : $this.data('fileType'), download_file_name: fileName, page_event : {cs_file_download : true}});
		},
		activeEvent: function() {
			download.$link.off('click').on('click', download.fileModalOpen);
			download.$modal.on('hide.bs.modal', download.fileModalClose);
			download.$modal.find('.btn-download').on('click', download.fileDownload);
		}
	}

	recently.init();
	supportHelpLibrary();
	supportMenuInit();
	$('html').data('countrycode') == 'jp' && download.init();
	// 200429 END 전호근 - JP 다운로드 팝업
});